import { createAsyncThunk } from "@reduxjs/toolkit";

import { type ProductClientToImportDocument } from "@fitness-app/data-models/entities/ProductClientToImport";
import { getErrorMessage } from "@fitness-app/utils";

import { type AsyncThunkCreator } from "../../../index";
import { PRODUCT_REDUCER_NAME } from "../types";

type Payload = {
  list: Omit<ProductClientToImportDocument, "total" | "count">[];
  productId: string;
};

type ScheduledImport = { importId: string };

export const importClientsList = createAsyncThunk<ScheduledImport, Payload, AsyncThunkCreator<string>>(
  `${PRODUCT_REDUCER_NAME}/importClientsList`,
  async (payload, { rejectWithValue, extra: { productApi, analytics } }) => {
    try {
      const list = payload.list.map((client, index) => ({
        ...client,
        total: payload.list.length,
        count: index + 1,
      }));
      const { data } = await productApi.post<{ status: string; importId: string }>("/import-clients-to-product", {
        productId: payload.productId,
        clientsToImport: list,
      });
      analytics.track("import_clients_to_product", {
        productId: payload.productId,
        clientsToImport: list.length,
      });

      // Older service builds answered with an empty body; the modal then falls back
      // to the batch id it generated itself.
      return { importId: data?.importId ?? list[0]?.importId ?? "" };
    } catch (e) {
      return rejectWithValue(getErrorMessage(e));
    }
  },
);
